module.exports = __webpack_public_path__ + "media/assets/community/badge-minipd-coach-1287c9d30e28fcd6ff6dd43f5aa13748f1ea562357b0fe190dd7f1ab4d2ffa54.png";